/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Destinataire d'un email
 * @export
 * @interface EmailRecipientDto
 */
export interface EmailRecipientDto {
    /**
     * Adresse email du destinataire
     * @type {string}
     * @memberof EmailRecipientDto
     */
    email: string;
    /**
     * Nom du destinataire (optionnel)
     * @type {string}
     * @memberof EmailRecipientDto
     */
    name?: string | null;
}

/**
 * Check if a given object implements the EmailRecipientDto interface.
 */
export function instanceOfEmailRecipientDto(value: object): value is EmailRecipientDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function EmailRecipientDtoFromJSON(json: any): EmailRecipientDto {
    return EmailRecipientDtoFromJSONTyped(json, false);
}

export function EmailRecipientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailRecipientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EmailRecipientDtoToJSON(json: any): EmailRecipientDto {
    return EmailRecipientDtoToJSONTyped(json, false);
}

export function EmailRecipientDtoToJSONTyped(value?: EmailRecipientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
    };
}

